import { useAtom } from "jotai";
import { Button } from "../../../components/ui/button";
import { Lightbulb, Smile, Glasses } from "lucide-react";
import { userIdentity } from "@/app/store";
import { useState } from "react";

interface ValidateIdentityProps {
  goToNextStep: () => void;
}

const ValidateIdentity = ({ goToNextStep }: ValidateIdentityProps) => {
  const [userIdentityData] = useAtom(userIdentity);
  const [isPending, setIsPending] = useState(false);

  const handleValidateIdentity = () => {
    setIsPending(true);
    try {
      const url = `${import.meta.env.VITE_VALIDACAO_URL}/${userIdentityData.id}`;
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        setTimeout(() => {
          setTimeout(() => {
            goToNextStep();
          }, 3000);
        }, 3000);
      }
    } catch (error) {
      console.error("Erro ao validar identidade:", error);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 sm:gap-6 text-black03">
      <div className="text-center sm:text-left">
        <h2 className="text-lg sm:text-2xl font-semibold leading-tight">
          Para finalizar vamos validar a sua identidade
        </h2>
      </div>

      <div className="flex flex-col gap-4 sm:gap-6">
        <div className="flex items-center gap-3 sm:gap-4">
          <Lightbulb className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
          <span className="text-xs sm:text-sm">Escolha uma área bem iluminada</span>
        </div>

        <div className="flex items-center gap-3 sm:gap-4">
          <Smile className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
          <span className="text-xs sm:text-sm">Mantenha uma expressão neutra</span>
        </div>

        <div className="flex items-center gap-3 sm:gap-4">
          <Glasses className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
          <span className="text-xs sm:text-sm">
            Remova acessórios que possam cobrir seu rosto
          </span>
        </div>
      </div>

      <div className="flex gap-4 mt-2">
        <Button
          type="button"
          onClick={handleValidateIdentity}
          disabled={isPending}
          className="h-11 sm:h-12 flex-1 bg-primary text-white hover:bg-primary/90 text-sm sm:text-base"
        >
          {isPending ? "Tentar novamente" : "Validar identidade"}
        </Button>
      </div>
    </div>
  );
};

export default ValidateIdentity;
